import { render, staticRenderFns } from "./UrlList.vue?vue&type=template&id=f0649f16&scoped=true&"
import script from "./UrlList.vue?vue&type=script&lang=js&"
export * from "./UrlList.vue?vue&type=script&lang=js&"
import style0 from "./UrlList.vue?vue&type=style&index=0&id=f0649f16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0649f16",
  null
  
)

export default component.exports